import { m, type MithrilVNode } from '../../mithril';
import { addStyles } from '../theme';

const CSS = {
	sidebar: 'c-Sidebar',
	leftSidebar: 'c-LeftSidebar',
	rightSidebar: 'c-RightSidebar',
};

const styles = {
	[CSS.sidebar]: {
		width: '20%',
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.leftSidebar]: {
		'min-width': '350px',
	},
	[CSS.rightSidebar]: {
		'min-width': '360px',
	},
};

addStyles(styles);

export class Sidebar {
	view(isLeft: boolean, children?: MithrilVNode | MithrilVNode[]) {
		return m(
			'div',
			{
				className: `${CSS.sidebar} ${isLeft ? CSS.leftSidebar : CSS.rightSidebar}`,
			},
			children
		);
	}
}
